import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  ButtonWrapper,
} from '../../components';

import './style.scss';

const Forbidden = () => {
  const { t } = useTranslation();
  return (
    <div className="Forbidden">
      <h1>{t('pages.403.title')}</h1>
      <p>{t('pages.403.body')}</p>
      <div className="Buttonwrapper">
        <ButtonWrapper type="primary" href={t('pages.403.primary_button.url')}>{t('pages.403.primary_button.link')}</ButtonWrapper>
        <ButtonWrapper type="secondary" href={t('pages.403.secondary_button.url')}>{t('pages.403.secondary_button.link')}</ButtonWrapper>
      </div>
    </div>
  );
};

export default Forbidden;
